// Shared class name constant to ensure form.ts and goal-modal.tsx stay in sync
// This class is used by RichTextareaEditor component and targeted by error styles in form.ts
export const RICH_TEXTAREA_EDITOR_CLASS = 'rich-textarea-editor';
